import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _SVGIconWithSizes;

import { createSvg } from "../createSvg";
import { IconSize, SVGIconWithSizes } from "../interfaces";
export default createSvg('IconChevronDown', new SVGIconWithSizes((_SVGIconWithSizes = {}, _defineProperty(_SVGIconWithSizes, IconSize.ExtraSmall, {
  paths: ['M7.29324 10.7072C7.68424 11.0982 8.31624 11.0982 8.70724 10.7072L12.7072 6.70725C13.0982 6.31625 13.0982 5.68425 12.7072 5.29325C12.3162 4.90225 11.6842 4.90225 11.2932 5.29325L8.00024 8.58625L4.70724 5.29325C4.51224 5.09825 4.25624 5.00025 4.00024 5.00025C3.74424 5.00025 3.48824 5.09825 3.29324 5.29325C2.90224 5.68425 2.90224 6.31625 3.29324 6.70725L7.29324 10.7072Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), _defineProperty(_SVGIconWithSizes, IconSize.Small, {
  paths: ['M3.29324 7.70725L9.29324 13.7072C9.68424 14.0982 10.3162 14.0982 10.7072 13.7072L16.7072 7.70725C17.0982 7.31625 17.0982 6.68425 16.7072 6.29325C16.3162 5.90225 15.6842 5.90225 15.2932 6.29325L10.0002 11.5862L4.70724 6.29325C4.51224 6.09825 4.25624 6.00025 4.00024 6.00025C3.74424 6.00025 3.48824 6.09825 3.29324 6.29325C2.90224 6.68425 2.90224 7.31625 3.29324 7.70725'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), _defineProperty(_SVGIconWithSizes, IconSize.Medium, {
  paths: ['M3.95187 9.2487L11.1519 16.4487C11.6211 16.9179 12.3795 16.9179 12.8487 16.4487L20.0487 9.2487C20.5179 8.7795 20.5179 8.0211 20.0487 7.5519C19.5795 7.0827 18.8211 7.0827 18.3519 7.5519L12.0003 13.9035L5.64867 7.5519C5.41467 7.3179 5.10747 7.2003 4.80027 7.2003C4.49307 7.2003 4.18587 7.3179 3.95187 7.5519C3.48267 8.0211 3.48267 8.7795 3.95187 9.2487'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), _defineProperty(_SVGIconWithSizes, IconSize.Large, {
  paths: ['M5.2692 12.3316L14.8692 21.9316C15.4948 22.5572 16.506 22.5572 17.1316 21.9316L26.7316 12.3316C27.3572 11.706 27.3572 10.6948 26.7316 10.0692C26.106 9.4436 25.0948 9.4436 24.4692 10.0692L16.0004 18.538L7.5316 10.0692C7.2196 9.7572 6.81 9.6004 6.4004 9.6004C5.9908 9.6004 5.5812 9.7572 5.2692 10.0692C4.6436 10.6948 4.6436 11.706 5.2692 12.3316'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));